export default function(words) {
   const words_array = words.split(" ");
   let new_words = [];
   words_array.forEach(word => {
      new_words.push(word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
   });
   return new_words.join(' ');
}